<ion-header class="ion-no-border ion-header-modal-desktop">
  <ion-toolbar [class.is-touch]="!isDesktop">
    <ion-buttons slot="end" *ngIf="isDesktop">
      <ion-button data-cy="close-modal-button" (click)="closeModal()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-content-modal-desktop">
  <ion-grid>
    <section>
      <h3 data-cy="homepage-title-help-text">
        {{ 'i18n.helpTooltips.desktop.homepage.title.help' | translate }}
      </h3>
      <ion-row>
        <ion-col>
          <div class="page-name" data-cy="page-title-text">
            {{ sectionName | translate }}
          </div>
          <p class="main-help-text" data-cy="page-tip-need-help-text">
            {{
              'i18n.helpTooltips.desktop.homepage.tip.needMoreHelp' | translate
            }}
            <a
              href="https://www.usfoods.com/our-services/moxe-help-center.html"
              class="help-center-link"
              target="_BLANK"
              data-cy="modal-help-center-link"
              >{{
                'i18n.helpTooltips.desktop.homepage.title.helpCenter'
                  | translate
              }}</a
            >.
          </p>
        </ion-col>
      </ion-row>

      <ion-row class="tiles" *ngFor="let term of terms">
        <ion-col
          size="4"
          size-sm="2"
          [attr.data-cy]="term.dataCy + '-title-tile-text'"
        >
          {{ term.title | translate }}
        </ion-col>
        <ion-col
          size="8"
          size-sm="10"
          [attr.data-cy]="term.dataCy + '-tip-tile-text'"
        >
          <span>{{ term.definition | translate }}</span>
        </ion-col>
      </ion-row>
    </section>
  </ion-grid></ion-content
>
